import { render, staticRenderFns } from "./PointGeometry.vue?vue&type=template&id=dafa7556&scoped=true&"
import script from "./PointGeometry.vue?vue&type=script&lang=js&"
export * from "./PointGeometry.vue?vue&type=script&lang=js&"
import style0 from "./PointGeometry.vue?vue&type=style&index=0&id=dafa7556&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dafa7556",
  null
  
)

export default component.exports